import { IResponseData } from '@/core/interfaces/common'

import { http } from '@/utils/http'

import {
  TransactionConfirmRequest,
  TransactionResponse,
} from './OrdersInterface'

class OrdersService {
  async getOrders(
    perPage: number,
  ): Promise<IResponseData<TransactionResponse[]>> {
    const res = await http.get<IResponseData<TransactionResponse[]>>(
      `/profile/exchanges?perpage=${perPage}`,
    )
    return res.data
  }

  async getOrder(id: string): Promise<TransactionResponse> {
    const res = await http.get<{ transaction: TransactionResponse }>(
      `/exchange/${id}`,
    )
    return res.data.transaction
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async confirmOrder(data: TransactionConfirmRequest): Promise<any> {
    const res = await http.post(`/exchange/${data.id}?is_agree=${data.agree}`)
    return res.data
  }

  async closeOrder(id: string): Promise<TransactionResponse> {
    const res = await http.post(`/exchange/${id}?action=close`)
    return res.data
  }
}

export default new OrdersService()
